module.exports = __webpack_public_path__ + "static/media/profile_pic_plh.c7939e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/profile_pic_plh.png
// module id = 583
// module chunks = 0